import { Injectable, enableProdMode } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TbAuthService } from '@tb/auth';
import { StartupUtils } from 'src/app/commons/startup-utils';
import { environment } from 'src/environments/environment';
import { environmentLoader as environmentLoaderPromise } from 'src/environments/environmentLoader';

// import { TranslateService } from '@ngx-translate/core';

// @Injectable({
//     providedIn: 'root'
// })
// export class AppInitService {
//     constructor(private translate: TranslateService) {}

//     Init() {
//         return new Promise(resolve => {
//             this.translate.setDefaultLang(this.translate.getBrowserLang());
//             resolve();
//         });
//     }
// }

// ---------------------------------------------------------------------------------
@Injectable({
    providedIn: 'root',
})
export class AppInitService {
    constructor(private translate: TranslateService, private authService: TbAuthService) {}

    Init() {
        return new Promise((resolve, reject) => {
            //codice migliorabile andando a prendere la lingua direttamente dal db invece che dal localStorage
            let language: string;
            if (this.authService.isSessionStorage() && sessionStorage.getItem('selectedLanguage')) {
                language = sessionStorage.getItem('selectedLanguage').substr(0, 2).toLowerCase();
            } else if (!this.authService.isSessionStorage() && localStorage.getItem('selectedLanguage')) {
                language = localStorage.getItem('selectedLanguage').substr(0, 2).toLowerCase();
            }
            if (language === 'it' || language === 'en' || language === 'de') {
                this.translate.setDefaultLang(language);
            } else {
                this.translate.setDefaultLang(StartupUtils.GetUserLanguage());
            }
            environmentLoaderPromise
                .then((env) => {
                    // if (env.production) {
                    //     enableProdMode();
                    // }
                    resolve(env);
                    environment.settings = env.settings;
                    environment.auth = env.auth;
                    environment.production = env.production;
                })
                .catch(() => {
                    reject();
                });
        });
    }
}
